import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useListView } from '../core/ListViewProvider';

const PaymentMethodEditModalHeader: FC = () => {
  const { itemIdForUpdate, setItemIdForUpdate } = useListView();
  const intl = useIntl();

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>
        {itemIdForUpdate
          ? intl.formatMessage({ id: 'PAYMENT_METHOD_PAGE.EDIT' })
          : intl.formatMessage({ id: 'PAYMENT_METHOD_PAGE.ADD' })}
      </h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => setItemIdForUpdate(undefined)}
      >
        <span className='svg-icon svg-icon-1'>×</span>
      </div>
    </div>
  );
};

export { PaymentMethodEditModalHeader };
